import { render, staticRenderFns } from "./SignPage.vue?vue&type=template&id=6c1e7b2a&scoped=true"
import script from "./SignPage.vue?vue&type=script&lang=js"
export * from "./SignPage.vue?vue&type=script&lang=js"
import style0 from "./SignPage.vue?vue&type=style&index=0&id=6c1e7b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e7b2a",
  null
  
)

export default component.exports